'use strict';

angular.module('bbw', [
    'ngMessages',
    'ngTouch',
    'safeApply',
    'valdr',
    'bbwDateSelect',
    'vesparny.fancyModal',
    'ngPinchZoom',
    'vr.directives.slider',
    'angular-svg-round-progress',
    'ui.sortable',
    'inform',
    'inform-exception',
    'inform-http-exception',
    'ui.select'
]).
    config(['$interpolateProvider', '$locationProvider', 'uiSelectConfig', '$qProvider', function($interpolateProvider, $locationProvider, uiSelectConfig, $qProvider) {
        $interpolateProvider.startSymbol('{:');
        $interpolateProvider.endSymbol(':}');
        $locationProvider.hashPrefix('');
        $locationProvider.html5Mode(true);

        uiSelectConfig.theme = 'selectize';
        uiSelectConfig.resetSearchInput = false;

        $qProvider.errorOnUnhandledRejections(false);
    }]).
    config(['valdrProvider', function(valdrProvider) {
        valdrProvider.addConstraints(bbw.constraints);
    }]).
    filter('plural', bbw.filter.plural).
    filter('url', bbw.filter.url).
    filter('profileUrl', bbw.filter.profileUrl).
    filter('ago', bbw.filter.ago).
    filter('contains', bbw.filter.contains).
    filter('striptags', function() {
        return function(text, maxlen) {
            text = text ? String(text).replace(/<(p|br|li|div|h[1-6])\s*\/?>/gmi, ' ').replace(/<[^>]+>/gm, '').trim() : '';
            if (maxlen && text.length > maxlen) {
                text = text.substr(0, maxlen) + '...';
            }
            return text;
        };
    }).
    filter('dump', function() {
        return function dump(value) {
            if (!angular.isObject(value)) {
                return value;
            }
            if (angular.isFunction(value)) {
                return '[Function]';
            }
            var result = angular.isArray(value) ? [] : {};
            angular.forEach(value, function(v, k) {
                if (!angular.isString(k) || k.charAt(0) != '$') {
                    result[k] = dump(v);
                }
            });
            return result;
        };
    }).
    factory('bbw.ConfigSvc', [function() {
        if (angular.isUndefined(bbw.configuration)) {
            throw new Error("bbw.configuration is undefined");
        }
        return new ngtk.Config(bbw.configuration);
    }]).
    factory('rpcClient', ['bbw.ConfigSvc', '$injector', function(config, $injector) {
        return $injector.instantiate(ngtk.rpcClient.Client, {
            'rpc_url': config.require('api.rpc_url')
        });
    }]).
    factory('bbw.DebounceSvc', ['$injector', function($injector) {
        var debouncer = $injector.instantiate(ngtk.Debouncer);
        return debouncer.debounce.bind(debouncer);
    }]).
    factory('modelFactory', ['$injector', function($injector) {
        return new ngtk.model.Factory($injector, bbw.model);
    }]).
    factory('setWindowTitle', ['$rootScope', function($rootScope) {
        var svc = new bbw.service.WindowTitleSvc($rootScope);
        return svc.setWindowTitle.bind(svc);
    }]).
    value('bbwUrls', {}).
    value('serverTimestamp', document.documentElement.getAttribute('data-ts')).
    value('enabledSocAuth', document.documentElement.getAttribute('data-soc').split(',')).
    service('bbw.StatsSvc', bbw.service.StatsSvc).
    service('bbw.LayoutTypeSvc', bbw.service.LayoutTypeSvc).
    service('bbw.OffsetCalcSvc', bbw.service.OffsetCalcSvc).
    service('bbw.LocationSvc', bbw.service.LocationSvc).
    service('bbw.RedirectSvc', bbw.service.RedirectSvc).
    service('bbw.ServerTimeSvc', bbw.service.ServerTimeSvc).
    service('bbw.MsgToHtmlSvc', bbw.service.MsgToHtmlSvc).
    service('bbw.AuthSvc', bbw.service.AuthSvc).
    service('bbw.AuthUserAvatarSvc', bbw.service.AuthUserAvatarSvc).
    service('bbw.UserSettingsSvc', bbw.service.UserSettingsSvc).
    service('growl', bbw.service.GrowlSvc).
    service('bbw.RetinaDetectorSvc', bbw.service.RetinaDetectorSvc).
    service('bbw.PhotoAlbumGallerySvc', bbw.service.PhotoAlbumGallerySvc).
    service('bbw.ChatClientFactory', bbw.service.chat.ClientFactory).
    service('bbw.ChatSvc', bbw.service.ChatSvc).
    service('bbw.ChatUnreadCountSvc', bbw.service.ChatUnreadCountSvc).
    service('bbw.FeedbackUnreadCountSvc', bbw.service.FeedbackUnreadCountSvc).
    service('bbw.FeedUnreadCountSvc', bbw.service.FeedUnreadCountSvc).
    service('bbw.SmileySvc', bbw.service.SmileySvc).
    service('bbw.TruncateSvc', bbw.service.TruncateSvc).
    service('bbw.PostProviderSvc', bbw.service.PostProviderSvc).
    service('bbw.GeoLocationRepository', bbw.service.GeoLocationRepository).
    component('bbwLocationPicker', bbw.LocationPickerComponent).
    component('bbwStepButtons', bbw.StepButtonsComponent).
    directive('bbwLocationInput', bbw.directive.bbwLocationInput).
    directive('bbwEmailNotExists', bbw.directive.bbwEmailNotExists).
    directive('bbwMinAge', bbw.directive.bbwMinAge).
    directive('bbwPassword', bbw.directive.bbwPassword).
    directive('sticky', bbw.directive.sticky).
    directive('longTap', bbw.directive.longTap).
    directive('bbwHref', bbw.directive.bbwHref).
    directive('bbwTouchHref', bbw.directive.bbwTouchHref).
    directive('bbwLayoutType', bbw.directive.bbwLayoutType).
    directive('bbwPageTitle', bbw.directive.bbwPageTitle).
    directive('bbwBindCompile', bbw.directive.bbwBindCompile).
    directive('bbwPage', bbw.directive.bbwPage).
    directive('bbwAuthUserAvatar', bbw.directive.bbwAuthUserAvatar).
    directive('bindNl2br', bbw.directive.bindNl2Br).
    directive('bindUnsafe', bbw.directive.bindUnsafe).
    directive('bbwChecklist', bbw.directive.bbwChecklist).
    directive('bbwChecklistItem', bbw.directive.bbwChecklistItem).
    directive('bbwChecklistRequired', bbw.directive.bbwChecklistRequired).
    directive('bbwTabs', bbw.directive.bbwTabs).
    directive('bbwTab', bbw.directive.bbwTab).
    directive('bbwDropdown', bbw.directive.bbwDropdown).
    directive('bbwDropdownList', bbw.directive.bbwDropdownList).
    directive('bbwPaginator', bbw.directive.bbwPaginator).
    directive('bbwClickScroll', bbw.directive.bbwClickScroll).
    directive('bbwSubmit', bbw.directive.bbwSubmit).
    directive('bbwToggle', bbw.directive.bbwToggle).
    directive('bbwFileUploadDelegate', bbw.directive.bbwFileUploadDelegate).
    directive('bbwIsTouchClass', bbw.directive.bbwIsTouchClass).
    directive('bbwTouchClickTitle', bbw.directive.bbwTouchClickTitle).
    directive('bbwUrl', bbw.directive.bbwUrl).
    directive('bbwMore', bbw.directive.bbwMore).
    directive('bbwPhotoSrc', bbw.directive.bbwPhotoSrc).
    directive('bbwPhotoMontage', bbw.directive.bbwPhotoMontage).
    directive('bbwScrollHere', bbw.directive.bbwScrollHere).
    directive('bbwUpdateOn', bbw.directive.bbwUpdateOn).
    directive('bbwPristineOn', bbw.directive.bbwPristineOn).
    directive('bbwFixedPosition', bbw.directive.bbwFixedPosition).
    directive('bbwChatScroll', bbw.directive.bbwChatScroll).
    directive('bbwFocusOn', bbw.directive.bbwFocusOn).
    directive('bbwContentEditable', bbw.directive.bbwContentEditable).
    directive('bbwSmileySelectorDesktop', bbw.directive.bbwSmileySelectorDesktop).
    directive('bbwSmileySelectorTouch', bbw.directive.bbwSmileySelectorTouch).
    directive('bbwChatUnreadCount', bbw.directive.bbwChatUnreadCount).
    directive('bbwFeedbackUnreadCount', bbw.directive.bbwFeedbackUnreadCount).
    directive('bbwFeedUnreadCount', bbw.directive.bbwFeedUnreadCount).
    directive('bbwBindMsg', bbw.directive.bbwBindMsg).
    directive('bbwPostEditor', bbw.directive.bbwPostEditor).
    directive('bbwPostEditorControls', bbw.directive.bbwPostEditorControls).
    directive('bbwPostEditorOpen', bbw.directive.bbwPostEditorOpen).
    directive('bbwPostLikes', bbw.directive.bbwPostLikes).
    directive('bbwTimeRemaining', bbw.directive.bbwTimeRemaining).
    directive('bbwClickConfirm', bbw.directive.bbwClickConfirm).
    directive('bbwPageHelpTree', bbw.directive.bbwPageHelpTree).
    directive('bbwScrollWatch', bbw.directive.bbwScrollWatch).
    directive('bbwScrollKeep', bbw.directive.bbwScrollKeep).
    directive('bbwScrollBottom', bbw.directive.bbwScrollBottom).
    directive('bbwTopUsersPyramid', bbw.directive.bbwTopUsersPyramid).
    directive('bbwBanner', bbw.directive.bbwBanner).
    directive('bbwCountdown', bbw.directive.bbwCountdown).
    directive('bbwContestList', bbw.directive.bbwContestList).
    directive('bbwContestStatus', bbw.directive.bbwContestStatus).
    run(['$rootScope', 'bbw.ConfigSvc', 'bbwUrls', '$sce', 'bbw.LayoutTypeSvc',
        function($rootScope, configSvc, bbwUrls, $sce, layoutTypeSvc) {
            bbw.globalEvent = {
                mobileBack: 'mobile-back',
                mobileBackShow: 'mobile-back-show',
                mobileBackHide: 'mobile-back-hide',
                layoutTypeChange: 'layout-type-change'
            };

            var onMobileBack = undefined;
            $rootScope.$on(bbw.globalEvent.mobileBack, function(e) {
                onMobileBack && onMobileBack(e);
            });
            bbw.onMobileBack = function(scope, callback) {
                onMobileBack = callback;
                scope.$on('$destroy', function() {
                    if (onMobileBack === callback) {
                        onMobileBack = undefined;
                    }
                });
            };

            $rootScope.bbwUrls = bbwUrls;
            $rootScope.Config = angular.extend(angular.copy(configSvc._config), configSvc);

            $rootScope.bbwUserId = bbw.userId;
            $rootScope.bbwUserGender = bbw.userGender;

            var templateUrls = {};
            $rootScope.templateUrl = function(url) {
                if (angular.isUndefined(templateUrls[url])) {
                    templateUrls[url] = $sce.trustAsResourceUrl(bbw.templateUrl(url));
                }
                return templateUrls[url];
            };

            $rootScope.bbwMessages = bbw.messages;
            $rootScope.hasWebSocketSupport = angular.isDefined(window.WebSocket);
            $rootScope.layoutType = function() {
                return layoutTypeSvc.getLayoutType();
            };
            $rootScope.layoutTypeIs = function(types) {
                if (!angular.isArray(types)) {
                    types = [types];
                }
                var layoutType = layoutTypeSvc.getLayoutType();
                return types.indexOf(layoutType) >= 0;
            };
            $rootScope.hasTouch = layoutTypeSvc.hasTouch();

            $rootScope.emitMobileBack = function() {
                $rootScope.$broadcast(bbw.globalEvent.mobileBack);
            };

            $rootScope.mobileBack = {isVisible: false};
            $rootScope.$on(bbw.globalEvent.mobileBackShow, function(_, args) {
                $rootScope.mobileBack.isVisible = true;
                $rootScope.mobileBack.isVisibleOnTablet = args ? !!args.tablet : false;
            });
            $rootScope.$on(bbw.globalEvent.mobileBackHide, function() {
                $rootScope.mobileBack.isVisible = false;
                $rootScope.mobileBack.isVisibleOnTablet = false;
            });
        }]);
